<template>
  <div class="sport-live-tv-dialog">
    <Transition name="sport-live-tv-dialog" appear>
      <div class="sport-live-tv-dialog__card">
        <slot />
      </div>
    </Transition>
  </div>
</template>

<style lang="scss" scoped>
.sport-live-tv-dialog {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 0 16px;
  background-color: $black10;

  &__card {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 480px;
    max-width: 100%;
    padding: 24px;
    border-radius: 12px;
    background-color: $black18;
  }
}

.sport-live-tv-dialog-enter-active {
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}

.sport-live-tv-dialog-enter-from {
  opacity: 0;
  transform: translateY(12px);
}
</style>
